<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <!-- Left: Title -->
        <div class="d-flex flex-column align-items-start">
          <div class="page-title">{{ 'connectedArtists.yourConnectedArtists' | transloco }}</div>
        </div>
        <!-- Right: Filters & Actions -->
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" inputId="statusFilter"
            name="statusFilter" [placeholder]="'connectedArtists.filterByStatus' | transloco"
            [(ngModel)]="filters.ConnectionStatus"
          (onChange)="onStatusFilterChange($event)"></p-dropdown>
          <button pButton type="button" icon="fa fa-plus" [label]="'connectedArtists.inviteExternalArtist' | transloco"
          class="p-button-outlined p-button-sm" (click)="openInviteExternalUserDialog($event)"></button>
          <button pButton type="button" icon="fa fa-plus" [label]="'connectedArtists.inviteArtist' | transloco"
          class="p-button-outlined p-button-sm" (click)="openInviteDialog($event)"></button>
        </div>
      </div>
    </div>

    <!-- Skeleton Loader -->
    @if (isLoading) {
      <div class="row my-2">
        @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
          <div class="col-4 mt-3">
            <div class="skeleton-card">
              <div class="skeleton-image"></div>
              <div class="skeleton-details">
                <div class="skeleton-text skeleton-title"></div>
                <div class="skeleton-text skeleton-line"></div>
                <div class="skeleton-text skeleton-line short"></div>
                <div class="skeleton-text skeleton-line"></div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 text-center text-muted small mt-3">
          <i class="pi pi-spin pi-spinner me-2"></i> {{ 'connectedArtists.loadingArtists' | transloco }}
        </div>
      </div>
    }

    <!-- Connected artists — friendly cards -->
    @if (!isLoading) {
      <!-- Search -->
      <div class="ca-search">
        <i class="fa fa-search"></i>
        <input type="text" [(ngModel)]="searchTerm" name="caSearch"
          [placeholder]="'connectedArtists.search' | transloco" />
      </div>

      @if (displayedArtists.length === 0) {
        <div class="ca-empty">
          <i class="fa fa-users"></i>
          <p>{{ 'connectedArtists.noConnectionsFound' | transloco }}</p>
        </div>
      }

      <div class="ca-grid">
        @for (a of displayedArtists; track a.Id) {
          <div class="ca-card" [class.ca-clickable]="!authConfig.IsGalleryStaff" (click)="navigateToViewArtist(a)">

            <!-- Header: avatar + name + status -->
            <div class="ca-head">
              <img class="ca-avatar" [src]="a.ImgUrl || 'assets/images/No-Image.png'"
                (error)="$any($event.target).src='assets/images/No-Image.png'" [alt]="a.Name" />
              <div class="ca-head-text">
                <div class="ca-name">{{ a.Name }}</div>
                @if (a.IsInviteAccepted) {
                  <span class="ca-badge ca-accepted"><i class="fa fa-check-circle"></i> {{ 'connectedArtists.accepted' | transloco }}</span>
                } @else if (a.IsInitiatedByArtist) {
                  <span class="ca-badge ca-pending"><i class="fa fa-clock-o"></i> {{ 'connectedArtists.pending' | transloco }}</span>
                } @else {
                  <span class="ca-badge ca-sent"><i class="fa fa-paper-plane-o"></i> {{ 'connectedArtists.sent' | transloco }}</span>
                }
              </div>
            </div>

            <!-- Contact -->
            <div class="ca-contact">
              @if (a.Email) {
                <a class="ca-line ca-link" [href]="'mailto:' + a.Email" (click)="$event.stopPropagation()">
                  <i class="fa fa-envelope"></i> <span>{{ a.Email }}</span>
                </a>
              }
              @if (a.PhoneNumber || a.MobileNumber) {
                <div class="ca-line"><i class="fa fa-phone"></i> <span>{{ a.PhoneNumber || a.MobileNumber }}</span></div>
              }
              @if (a.AddressLine1 || a.AddressLine2) {
                <div class="ca-line"><i class="fa fa-map-marker"></i> <span>{{ a.AddressLine1 }} {{ a.AddressLine2 }}</span></div>
              }
            </div>

            <!-- Socials -->
            @if (a.Website || a.BusinessFacebookLink || a.BusinessInstagramLink || a.BusinessLinkedinLink) {
              <div class="ca-socials" (click)="$event.stopPropagation()">
                @if (a.Website) { <a [href]="a.Website" target="_blank" rel="noopener" title="Website"><i class="fa fa-globe"></i></a> }
                @if (a.BusinessFacebookLink) { <a [href]="a.BusinessFacebookLink" target="_blank" rel="noopener" title="Facebook"><i class="fa fa-facebook"></i></a> }
                @if (a.BusinessInstagramLink) { <a [href]="a.BusinessInstagramLink" target="_blank" rel="noopener" title="Instagram"><i class="fa fa-instagram"></i></a> }
                @if (a.BusinessLinkedinLink) { <a [href]="a.BusinessLinkedinLink" target="_blank" rel="noopener" title="LinkedIn"><i class="fa fa-linkedin"></i></a> }
              </div>
            }

            <!-- Dates -->
            <div class="ca-dates">
              @if (a.CreatedDate) { <span>{{ 'connectedArtists.invited' | transloco }} {{ a.CreatedDate | date:'dd MMM yyyy' }}</span> }
              @if (a.InvitationAccepted) { <span class="ca-dot">·</span><span>{{ a.InvitationAccepted | date:'dd MMM yyyy' }}</span> }
            </div>

            <!-- Actions (galleries only — staff are read-only) -->
            @if (!authConfig.IsGalleryStaff) {
              <div class="ca-actions" (click)="$event.stopPropagation()">
                @if (a.IsInviteAccepted) {
                  <button type="button" class="ca-btn ca-primary" (click)="navigateToViewArtist(a)">
                    <i class="fa fa-briefcase"></i> {{ 'connectedArtists.artworks' | transloco }}
                  </button>
                  <button type="button" class="ca-btn" (click)="ChatwithArtist($any(a))">
                    <i class="fa fa-comments"></i> {{ 'connectedArtists.chat' | transloco }}
                  </button>
                  <button type="button" class="ca-btn ca-icon" (click)="openNotesDialog(a)" [title]="'connectedArtists.notes' | transloco">
                    <i class="fa fa-sticky-note-o"></i>
                  </button>
                  <button type="button" class="ca-btn ca-icon ca-danger" (click)="deleteConnectedArtist(a)" [title]="'connectedArtists.delete' | transloco">
                    <i class="fa fa-trash"></i>
                  </button>
                } @else if (a.IsInitiatedByArtist) {
                  <button type="button" class="ca-btn ca-primary" (click)="goToConnectionRequestDetail(a)">
                    <i class="fa fa-external-link"></i> {{ 'connectedArtists.viewRequest' | transloco }}
                  </button>
                } @else {
                  <button type="button" class="ca-btn" (click)="navigateToViewArtist(a)">
                    <i class="fa fa-external-link"></i> {{ 'connectedArtists.viewProfile' | transloco }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Dialog for inviting an internal artist -->
<p-dialog [header]="'connectedArtists.artistInvitationManagement' | transloco" [(visible)]="inviteDialogVisible" [modal]="true"
  [style]="{ 'width': '500px' }" [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
  <!-- Logo section -->
  <div class="d-flex flex-column justify-content-center align-items-center p-4 mb-4">
    <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 250px;"
      [alt]="'connectedArtists.logo' | transloco" />
    </div>

    <!-- Form for selecting artist and adding comment -->
    <form class="form-horizontal px-3">
      <div class="form-group">
        <!-- Artist selection dropdown -->
        <div class="mb-4">
          <label class="form-label fw-semibold mb-2">
            <span class="text-danger">*</span> {{ 'connectedArtists.selectArtist' | transloco }}
          </label>
          <p-dropdown [options]="avalableArtist" [(ngModel)]="artistId" name="selectedArtistId"
            (onChange)="onArtistSelection($event)" appendTo="body" [filter]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" [filterMatchMode]="'contains'"
            [placeholder]="'connectedArtists.searchAndSelectArtist' | transloco" class="w-100" [showClear]="true"
          [filterPlaceholder]="'connectedArtists.typeToSearch' | transloco"></p-dropdown>
          <!-- Info alert for invitation -->
          <div class="alert alert-light border mt-3 p-3 small">
            <i class="pi pi-info-circle text-primary me-2"></i>
            {{ 'connectedArtists.invitationInfo' | transloco }}
          </div>
        </div>

        <!-- Comment section (visible only if artist is selected) -->
        @if (artistId) {
          <div class="mt-4">
            <label class="form-label fw-semibold mb-2">{{ 'connectedArtists.comment' | transloco }}</label>
            <div class="position-relative">
              <textarea id="comments" pInputTextarea rows="3" name="comments" [(ngModel)]="formData.InviteArtistComment"
              [placeholder]="'connectedArtists.addCommentHere' | transloco" class="form-control w-100"></textarea>
              <!-- Emoji picker button -->
              <div class="emoji-icon position-absolute cursor-pointer fs-5" (click)="openEmojiDialog('internal')"
                style="top: 60%; right: 0.5rem; transform: translateY(-50%);">
                😍
              </div>
            </div>
            <!-- Send invitation button -->
            <div class="dialog-footer mt-4">
              <button pButton type="button" (click)="sendInvitation()" [label]="'connectedArtists.sendInvitation' | transloco"
              class="w-100 p-button-outlined" [disabled]="!artistId"></button>
            </div>
          </div>
        }
      </div>
    </form>
  </p-dialog>

  <!-- Dialog for inviting an external artist -->
  <p-dialog [header]="'connectedArtists.inviteArtist' | transloco" [(visible)]="inviteExternalUserDialogVisible" [modal]="true"
    [style]="{ 'width': '480px' }" [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
    <!-- Logo section -->
    <div class="d-flex flex-column justify-content-center align-items-center p-4 mb-4">
      <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 250px;"
        [alt]="'connectedArtists.logo' | transloco" />
      </div>

      <!-- Form for entering external artist details -->
      <form class="form-horizontal px-3">
        <div class="form-group">
          <!-- Artist name input -->
          <div class="mb-3">
            <label for="fullName" class="form-label fw-semibold mb-2">
              <span class="text-danger me-1">*</span>{{ 'connectedArtists.artistName' | transloco }}
            </label>
            <input type="text" id="fullName" [(ngModel)]="inviteExternalUserData.Name" pInputText [placeholder]="'connectedArtists.artistName' | transloco"
              class="form-control" name="fullName" required />
            </div>
            <!-- Artist email input -->
            <div class="mb-4">
              <label for="email" class="form-label fw-semibold mb-2">
                <span class="text-danger me-1">*</span>{{ 'connectedArtists.artistEmail' | transloco }}
              </label>
              <input type="email" id="email" [(ngModel)]="inviteExternalUserData.Email" pInputText [placeholder]="'connectedArtists.artistEmail' | transloco"
                class="form-control" name="email" required />
              </div>
              <!-- Comment section -->
              <div>
                <label class="form-label fw-semibold mb-2">{{ 'connectedArtists.comment' | transloco }}</label>
                <div class="position-relative">
                  <textarea id="comments" pInputTextarea rows="3" name="comments"
                    [(ngModel)]="inviteExternalUserData.InviteExternalComment" [placeholder]="'connectedArtists.addCommentHere' | transloco"
                  class="form-control w-100"></textarea>
                  <!-- Emoji picker button -->
                  <div class="emoji-icon position-absolute cursor-pointer fs-5" (click)="openEmojiDialog('external')"
                    style="top: 45%; right: 0.5rem; transform: translateY(-50%);">
                    😍
                  </div>
                </div>
                <!-- Send invitation button -->
                <div class="dialog-footer mt-4">
                  <button pButton type="button" (click)="inviteExternalUser()" [label]="'connectedArtists.sendInvitation' | transloco"
                    class="w-100 p-button-outlined"
                  [disabled]="!inviteExternalUserData.Email || !inviteExternalUserData.Name"></button>
                </div>
              </div>
            </div>
          </form>
        </p-dialog>

        <!-- Stripe payment plan dialog -->
        @if (isStripeDisplayPlansDialogVisible) {
          <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
            [stripeAllPlans]="stripePlans"
          (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)"></stripe-payment-plan>
        }

        <!-- Notes dialog for connected artists -->
        @if (notesDialogVisible) {
          <connectedartists-notes [connectartist]="connectedArtists" [notesDialogVisible]="notesDialogVisible"
          (onCloseDialog)="closeNotesDialog($event)"></connectedartists-notes>
        }

        <!-- Emoji picker dialog -->
        @if (displayEmojiDialog) {
          <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
          (emojiClick)="addEmoji($event)"></app-emoji-list>
        }

        <!-- Dialog for upgrading account -->
        <p-dialog [(visible)]="displayUpgreadAccountDialog" [header]="'connectedArtists.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
          [style]="{width: '450px'}">
          <div class="dialog-content">
            <!-- Warning section for connection limit -->
            <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
              <div class="d-flex align-items-center">
                <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
                <div>
                  <strong>{{ 'connectedArtists.connectionLimitReached' | transloco }}</strong>
                  <p class="mb-2">
                    {{ 'connectedArtists.connectionLimitMessage' | transloco }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Main content for upgrade prompt -->
            <p class="lead p-2">
              {{ 'connectedArtists.upgradePromptMessage' | transloco }}
            </p>
            <!-- Upgrade call-to-action -->
            <div class="text-center mt-4">
              <a href="javascript:void(0);" (click)="onUpgradeAccount()">
                <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'connectedArtists.upgradePlan' | transloco"
                  class="rounded shadow-lg img-fluid" />
                </a>
              </div>
            </div>
          </p-dialog>
